// Commission Management Types

export enum CommissionMilestone {
  REGISTRATION = "REGISTRATION",
  KYC_VERIFIED = "KYC_VERIFIED",
  FIRST_DELIVERY = "FIRST_DELIVERY",
  RETAINED_30_DAYS = "RETAINED_30_DAYS",
  RETAINED_90_DAYS = "RETAINED_90_DAYS",
}

export enum CommissionStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  PAID = "PAID",
  CANCELLED = "CANCELLED",
}

export interface VendorCommission {
  id: string;
  vendorId: string;
  vendor?: {
    id: string;
    vendorCode: string;
    name: string;
    phone: string;
  };
  referralId: string;
  referral?: {
    id: string;
    referralCode: string;
    candidateName: string;
    candidatePhone: string;
  };
  milestone: CommissionMilestone;
  amount: number;
  status: CommissionStatus;
  eligibleAt: Date;
  approvedAt?: Date;
  approvedBy?: string;
  rejectedAt?: Date;
  rejectedBy?: string;
  rejectionReason?: string;
  paidAt?: Date;
  paidBy?: string;
  paymentMethod?: string;
  paymentReference?: string;
  paymentNotes?: string;
  notes?: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface CommissionStructure {
  id: string;
  milestone: CommissionMilestone;
  amount: number;
  description: string;
  isActive: boolean;
  effectiveFrom: Date;
  effectiveTo?: Date;
  createdAt: Date;
  updatedAt: Date;
}

export interface CommissionFilterParams {
  page?: number;
  limit?: number;
  status?: CommissionStatus;
  milestone?: CommissionMilestone;
  vendorId?: string;
  telecallerId?: string;
  dateFrom?: string;
  dateTo?: string;
}

export interface CommissionSummary {
  vendorId: string;
  vendorName: string;
  totalCommissions: number;
  totalAmount: number;
  pendingCount: number;
  pendingAmount: number;
  approvedCount: number;
  approvedAmount: number;
  paidCount: number;
  paidAmount: number;
  rejectedCount: number;
  rejectedAmount: number;
  byMilestone: Array<{
    milestone: CommissionMilestone;
    count: number;
    amount: number;
  }>;
}

export interface BulkApprovalResult {
  successCount: number;
  failedCount: number;
  totalAmount: number;
  errors?: Array<{
    commissionId: string;
    error: string;
  }>;
}

export interface PaymentDetails {
  paidBy: string;
  paymentMethod: string;
  paymentReference?: string;
  paymentDate?: string;
  paymentNotes?: string;
}
